export default {
  banner: {
    carouselAriaLabel: 'Destaques',
    goToSlideAriaLabel: 'Ir para destaque {{number}}',
  },
  cookieConsent: {
    title: 'Utilizamos cookies',
    description:
      'Utilizamos cookies para melhorar a sua experiência de navegação e analisar o tráfego do site. Pode aceitar ou rejeitar cookies não essenciais.',
    accept: 'Aceitar',
    reject: 'Rejeitar',
  },
  news: {
    breadcrumbs: {
      home: 'Início',
      news: 'Notícias',
    },
    list: {
      title: 'Notícias',
      subtitle: 'Acompanhe as últimas novidades',
      loading: 'A carregar...',
      error: 'Erro ao carregar notícias.',
      empty: 'Nenhuma notícia.',
      readMore: 'Ler mais',
    },
    detail: {
      notFoundTitle: 'Notícia não encontrada',
      notFoundDescription: 'A notícia que procura pode ter sido removida ou não está disponível.',
      by: 'Por {{name}}',
    },
    newsletterPopup: {
      title: 'Subscreve a nossa newsletter!',
      description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore.',
      close: 'Fechar popup',
      imageAlt: 'Roupa',
    },
  },
  events: {
    breadcrumbs: {
      home: 'Início',
      events: 'Eventos',
    },
    list: {
      title: 'Eventos',
      subtitle: 'Acompanhe os nossos próximos eventos',
      loading: 'A carregar...',
      error: 'Erro ao carregar eventos.',
      empty: 'Nenhum evento encontrado.',
    },
    detail: {
      notFoundTitle: 'Evento não encontrado',
      notFoundDescription: 'O evento que procura pode ter sido removido ou não está disponível.',
    },
  },
  support: {
    common: {
      generalSubject: 'Assunto Geral',
      status: {
        open: 'Aberto',
        pending: 'Pendente',
        closed: 'Fechado',
      },
    },
    create: {
      back: 'Voltar',
      title: 'Novo Pedido de Suporte',
      requiredFieldsError: 'Preencha os campos obrigatórios.',
      channelUnavailableError: 'Canal indisponível. Tente novamente mais tarde.',
      successToast: 'Pedido de suporte criado com sucesso!',
      genericError: 'Erro ao criar pedido.',
      subjectLabel: 'Assunto',
      loadingSubjects: 'A carregar assuntos...',
      selectSubjectPlaceholder: 'Selecione um assunto',
      priorityLabel: 'Prioridade',
      priorityLow: 'Baixa',
      priorityMedium: 'Média',
      priorityHigh: 'Alta',
      priorityUrgent: 'Urgente',
      descriptionLabel: 'Descrição detalhada',
      descriptionPlaceholder: 'Descreva a sua questão ou problema...',
      submit: 'Submeter Pedido',
      cancel: 'Cancelar',
    },
    details: {
      back: 'Voltar',
      loadError: 'Ocorreu um erro ao carregar os detalhes do pedido.',
      notFound: 'Pedido de suporte não encontrado.',
      messageSentToast: 'Mensagem enviada com sucesso!',
      sendMessageError: 'Erro ao enviar mensagem.',
      ticketPrefix: 'Ticket #{{id}}',
      initialDescription: 'Descrição Inicial',
      noMessages: 'Sem mensagens.',
      newMessageLabel: 'Nova Mensagem',
      messagePlaceholder: 'Escreva a sua mensagem...',
      sendMessageAriaLabel: 'Enviar Mensagem',
    },
    list: {
      title: 'Apoio ao Cliente',
      newRequest: 'Novo Pedido',
      loadError: 'Ocorreu um erro ao carregar os tickets de suporte.',
      empty: 'Ainda não tem pedidos de suporte.',
      updatedAtPrefix: 'Atualizado a {{date}}',
      viewDetails: 'Ver Detalhes',
    },
  },
  favorites: {
    loginRequiredTitle: 'Inicie sessão para ver favoritos',
    loginRequiredDescription: 'Inicie sessão para guardar e consultar os seus produtos favoritos.',
    loginButton: 'Iniciar sessão',
    loginRequiredToast: 'Inicie sessão para adicionar aos favoritos',
    toggleError: 'Erro ao atualizar favoritos.',
    title: 'Favoritos ({{count}})',
    sortBy: 'Ordenar por:',
    sortRecent: 'Mais recentes',
    sortOldest: 'Mais antigos',
    sortAlphabetical: 'Ordem alfabética',
    emptyTitle: 'Nenhum favorito',
    emptyDescription: 'Ainda não guardou nenhum produto nos favoritos.',
  },
  designs: {
    title: 'Os meus designs',
    emptyTitle: 'Nada para ver aqui',
    emptyDescription: 'Ainda não tem nenhum design',
    previewUnavailable: 'Pré-visualização indisponível',
  },
  projects: {
    title: 'Os Meus Projetos',
    createNew: 'Criar Novo Projeto',
    emptyMessage: 'Ainda não tem projetos',
    createFirst: 'Criar o seu primeiro projeto',
    deleteAriaLabel: 'Eliminar {{title}}',
    productCount_one: '{{count}} Produto',
    productCount_other: '{{count}} Produtos',
  },
  pageBuilder: {
    news: {
      title: 'Notícias',
    },
    events: {
      title: 'Eventos',
    },
    products: {
      title: 'Produtos',
    },
    collections: {
      loading: 'A carregar categorias...',
      error: 'Erro ao carregar categorias',
      title: 'Categorias',
      viewMore: 'Ver Mais',
    },
    kits: {
      loading: 'Carregando kits...',
      error: 'Erro ao carregar kits',
      title: 'Kits',
      viewMore: 'Ver Mais',
    },
    video: {
      unavailable: 'O vídeo não está disponível',
      notSupported: 'Este navegador não suporta exibir vídeos.',
      title: 'Reprodutor de vídeo',
    },
    embed: {
      title: 'HTML incorporado',
    },
    productVariants: {
      loading: 'A carregar produtos...',
      error: 'Erro ao carregar produtos',
      badges: {
        featured: 'Recomendado',
        new: 'Novidade',
        promotion: 'Promoção',
        bestSeller: 'Mais vendidos',
        stockoff: 'Liquidação',
      },
    },
    form: {
      required: 'Obrigatório',
      selectPlaceholder: 'Selecionar',
      submitSuccess: 'Formulário enviado com sucesso',
      submitError: 'Ocorreu um erro. Tente novamente.',
      submit: 'Enviar',
    },
  },
}
